import { render, staticRenderFns } from "./CriteriaCard.vue?vue&type=template&id=1ef8817f&scoped=true&"
import script from "./CriteriaCard.vue?vue&type=script&lang=js&"
export * from "./CriteriaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8817f",
  null
  
)

export default component.exports